export const INTERNAL_APPLICATION_OFFICE_KEY = "HRM";
// value in URL ?type=internal or ?type=student
export const APPLICATION_TYPE_INTERNAL = "internal";
export const APPLICATION_TYPE_STUDENT = "student";
// value in Connexys API
export const APPLICATION_TYPE_STUDENT_CONNEXYS = "Student";
